import React from 'react'
import { useSpinnerContext } from '../../context/SpinnerContext'
import styles from './Spinner.module.scss'

const Spinner = (props) => {
  const obj = useSpinnerContext()
  return obj.isLoading ? (
    <div className={styles.spinnerOverlay}>
      <div className={styles.loader}></div>
    </div>
  ) : null
}

export default Spinner
